import drop from "../../images/icons/drop.png";
import img1 from "../../images/ouvrage/bassin/1.jpg";

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
} from "../ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";

const WaterPrice = () => {
  const images = [
    { id: 1, img: img1 },
    { id: 2, img: img1 },
  ];

  return (
    <div className="container px-4 mx-auto mt-20 mb-10 sm:px-6 lg:px-8">
      <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
        <div className="w-full md:w-2/3">
          <div className="text-xl font-bold">Bassins de stockage</div>
          <p className="mt-2 text-base text-justify">
            Les bassins de stockage permettent de protéger les riverains des
            inondations et de préserver le milieu naturel en limitant la
            pollution des rivières. En effet, en cas de fortes pluies, ils
            régulent les débits en évitant que, en cas de saturation des égouts,
            les eaux se répandent vers les habitations ou se déversent
            directement dans les rivières.
          </p>
          <p className="mt-5 text-base">
            Le bassin de stockage de Sèvres, créé par Hydreaulys en 2002, d'une
            capacité de 40 000 m³, est l'un des plus importants ouvrages
            construits par un syndicat intercommunal en Île-de-France.
          </p>
        </div>
        <div className="w-full md:w-1/3">
          <Card className="flex flex-col items-center justify-center p-4 bg-[#E8F5F1]">
            <CardHeader className="flex items-center justify-center">
              <CardDescription className="flex items-center justify-center">
                <div
                  className="w-16 h-16 sm:w-20 sm:h-20 bg-primary"
                  style={{
                    mask: `url(${drop}) no-repeat center`,
                    maskSize: "contain",
                    WebkitMask: `url(${drop}) no-repeat center`,
                    WebkitMaskSize: "contain",
                  }}
                />
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center">
              <p className="text-base font-bold">Bassins de stockage</p>
            </CardContent>
            <CardFooter className="text-center">
              <p className="text-base font-bold text-primary">40 000 m³</p>
            </CardFooter>
          </Card>
        </div>
      </div>

      <div className=" px-4 mx-auto mt-10 sm:mt-20 lg:mt-32">
        <Carousel opts={{ align: "start", loop: true }} className="w-full">
          <CarouselContent>
            {images.map((item) => (
              <CarouselItem key={item.id}>
                <div className="flex items-center justify-center w-full h-64 overflow-hidden bg-gray-200 rounded-lg sm:h-80 md:h-96">
                  <img
                    src={item.img}
                    alt="Bassin de stockage"
                    className="object-cover w-full h-full"
                  />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="absolute flex items-center justify-center border-none  text-white transform -translate-y-1/2 bg-teal-500 rounded-full   left-2 sm:left-4 top-1/2 hover:bg-teal-600" />
          <CarouselNext className="absolute flex items-center justify-center  border-none text-white transform -translate-y-1/2 bg-teal-500 rounded-full  right-2 sm:right-4 top-1/2 hover:bg-teal-600" />
        </Carousel>
      </div>
    </div>
  );
};

export default WaterPrice;
